class CommerceHeroSlider extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-slide]')];
    this.dots = [...this.querySelectorAll('[data-dot]')];
    this.current = 0;
    this.autoplay = this.dataset.autoplay === 'true';
    this.speed = Number(this.dataset.speed) || 6000;

    this.querySelector('[data-prev]')?.addEventListener('click', () => this.show(this.current - 1));
    this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.current + 1));
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index)));

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());

    if (Shopify.designMode) {
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.indexOf(event.target);
        if (index >= 0) this.show(index, false);
      });
    }

    this.start();
  }

  show(index, restart = true) {
    if (!this.slides.length) return;
    this.current = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, slideIndex) => {
      const active = slideIndex === this.current;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
    });
    this.dots.forEach((dot, dotIndex) => {
      const active = dotIndex === this.current;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', String(active));
    });
    if (restart) {
      this.stop();
      this.start();
    }
  }

  start() {
    if (!this.autoplay || this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.stop();
    this.timer = window.setInterval(() => this.show(this.current + 1, false), this.speed);
  }

  stop() {
    window.clearInterval(this.timer);
  }
}

if (!customElements.get('commerce-hero-slider')) {
  customElements.define('commerce-hero-slider', CommerceHeroSlider);
}
